window.addEventListener('DOMContentLoaded', function () {
	const lvcSwiper = new Swiper('.swiper', {
		loop: true,
		speed: 1000,
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		}
	});
});
